import { Component, effect, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

interface ErrorConfig {
  titulo: string;
  descripcion: string;
  textoBoton?: string;
}

@Component({
  selector: 'app-claveunica-error',
  standalone: true,
  imports: [],
  templateUrl: './claveunica-error.component.html',
  styleUrl: './claveunica-error.component.css',
})
export class ClaveUnicaErrorComponent {
  private readonly router = inject(Router);
  private readonly titleService = inject(Title);

  private rutaAnterior = '/claveunica';

  public readonly tipoError = signal<'auth' | 'rutdiff' | 'general'>('general');

  public readonly CONFIGS: Record<string, ErrorConfig> = {
    auth: {
      titulo: 'Sesión expirada',
      descripcion: 'Tu sesión ha expirado por seguridad.',
      textoBoton: 'Volver a intentarlo',
    },
    rutdiff: {
      titulo: 'No pudimos validar tu identidad',
      descripcion:
        'Lo sentimos, no pudimos autenticar tu identidad debido a que se el rut validado no coincide con el rut solicitando el traspaso de AFP.',
      textoBoton: 'Volver a intentarlo',
    },
    general: {
      titulo: 'No pudimos validar tu identidad',
      descripcion:
        'Lo sentimos, no pudimos autenticar tu identidad debido a que el servicio de Clave Única no se encuentra disponible te recomendamos utilizar otro método.',
      textoBoton: 'Intentar Clave Dinámica',
    },
  };

  public readonly configuracionActual = signal(
    this.CONFIGS[this.tipoError() || 'general'],
  );

  constructor() {
    // Cambiar el título de la página
    this.titleService.setTitle('ClaveÚnica - Error');

    const nav = this.router.currentNavigation();
    const error = nav?.extras.state?.['tipoError'];
    const rutaPrevia = nav?.extras.state?.['rutaAnterior'];

    if (error) {
      this.tipoError.set(error);
    }

    this.rutaAnterior =
      sessionStorage.getItem('claveunica_error_url') || rutaPrevia;

    effect(() => {
      this.configuracionActual.set(this.CONFIGS[this.tipoError() || 'general']);
    });
  }

  public navegarALogin() {
    console.warn('[DEBUG] Navegando a ruta anterior:', this.rutaAnterior);
    // Usar navigateByUrl para manejar correctamente URLs con query parameters
    window.location.href = this.rutaAnterior;
  }

  public volverAlInicio() {
    this.router.navigate(['/claveunica/error']);
  }
}
